"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(window) {
  if (!Function.prototype.bind) {
    return true;
  }

  var _window$navigator = window.navigator,
      webdriver = _window$navigator.webdriver,
      languages = _window$navigator.languages;

  if (webdriver) {
    return true;
  }

  if (languages && languages.length === 0) {
    return true;
  }

  try {
    languages.push('hello');
    return true;
  } catch (e) {// empty
  }

  var stack;

  try {
    null[0]();
  } catch (e) {
    stack = e.stack;
  }

  if (stack && /ph\x61n\x74om|n\x6fde[^_]/i.test(stack)) {
    return true;
  }

  return false;
};

exports["default"] = _default;
//# sourceMappingURL=isSuspectedBot.js.map